<template>
  <div
    :class="[
      'list-item-container',
      header ? 'header' : '',
      tall ? 'tall' : '',
      flexColumn ? 'flex-column' : '',
    ]"
  >
    <v-list-item
      :class="[
        'list-item pl-2',
        `text-${dropdownData.right ? 'right' : 'left'}`,
        ...listItemClass,
      ]"
      @click="handleClick"
      @mouseenter="mouseenter"
      @mouseleave="mouseleave"
      v-on="inputListeners"
    >
      <div :class="{ 'd-flex': isBeta || isSoon || isUpgrade || isNew }">
        <slot />
        <StatusBadge
          :is-beta="isBeta"
          :is-soon="isSoon"
          :is-upgrade="isUpgrade"
          :is-new="isNew"
        />
      </div>
    </v-list-item>
  </div>
</template>

<script>
import StatusBadge from '@/components/shared/StatusBadge.vue';

export default {
  name: 'SubmenuDropdownListItem',
  components: {
    StatusBadge,
  },
  inject: {
    dropdownData: {
      default: () => ({
        outsideRoot: () => {},
        handleActiveElementChange: () => {},
      }),
    },
  },
  props: {
    handleActiveElementChange: {
      type: Function,
      default: () => {},
    },
    right: {
      type: Boolean,
    },
    outsideRoot: {
      type: Function,
      default: () => {},
    },
    header: {
      type: Boolean,
      default: false,
    },
    listItemClass: {
      type: Array,
      default: () => [],
    },
    tall: {
      type: Boolean,
      default: false,
    },
    flexColumn: {
      type: Boolean,
      default: false,
    },
    isBeta: {
      type: Boolean,
      default: false,
    },
    isSoon: {
      type: Boolean,
      default: false,
    },
    isUpgrade: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    inputListeners() {
      const vm = this;
      // `Object.assign` merges objects together to form a new object
      return {
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        // This ensures that the component works with v-model
        'update:modelValue': function (event) {
          vm.$emit('update:modelValue', event.target.value);
        },
      };
    },
  },
  methods: {
    mouseenter(e) {
      this.dropdownData.handleActiveElementChange(e.target);
    },
    mouseleave(e) {
      if (this.dropdownData.outsideRoot(e.relatedTarget)) {
        this.dropdownData.handleActiveElementChange(null);
      }
    },
    handleClick() {
      setTimeout(() => {
        if (this.dropdownData.closeOnClick) {
          this.dropdownData.handleActiveElementChange(null);
        }
      }, 0);
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  pointer-events: none;
  :deep(.v-list-item__content) {
    color: @text-darkest !important;
    font-size: 13px;
    font-weight: 600;
  }
}
.list-item-container.header, .list-item-container.header .v-list-item:hover {
  cursor: default;
}
.list-item-container.header .v-list-item:hover::before {
  background: white;
  opacity: 0;
}
.v-list-item {
  cursor: pointer;
}

.list-item-container {
  :deep(.v-list-item__content) {
    overflow: visible;
    grid-area: unset;
  }

  :deep(.v-list-item--variant-text .v-list-item__overlay) {
    background: @bg-brand-default;
  }

  &:hover {
    :deep(.v-list-item__content) {
      color: @text-brand;
    }
  }
}
.tall :deep(.v-list-item.list-item) {
  text-align: left;
  height: 60px;
  min-height: 60px;
}

.flex-column :deep(.v-list-item.list-item) {
  flex-direction: column;
  align-items: flex-start;
}

.v-theme--light.v-list-item--disabled {
  color: @text-darkest;
  cursor: default;
}
</style>
